@for (toast of toasts(); track toast) {
  <div
    class="toast-frame {{toast.class || ''}}"
    [class.position-horizontal-left]="toast.horizontalPosition === 'left'"
    [class.position-horizontal-center]="!toast.horizontalPosition || toast.horizontalPosition === 'center'"
    [class.position-horizontal-right]="toast.horizontalPosition === 'right'"
    [class.position-vertical-bottom]="!toast.verticalPosition || toast.verticalPosition === 'bottom'"
    [class.position-vertical-top]="toast.verticalPosition === 'top'"
    [class.position-vertical-center]="toast.verticalPosition === 'center'">
    <div class="toast-notice w-toast {{toast.bgColor || ''}}"
      [class.toast-small]="!toast.size || toast.size === 'small'"
      [class.toast-medium]="toast.size === 'medium'"
      [class.toast-large]="toast.size === 'large'"
      [class.content-align-left]="!toast.contentAlignment || toast.contentAlignment === 'left'"
      [class.content-align-center]="toast.contentAlignment === 'center'"
      [class.content-align-right]="toast.contentAlignment === 'right'"
      [class.toast-clickable]="toast.onClickCallback"
      [style.height]="toast.height ? toast.height.value + toast.height.unit : null"
      (click)="onToastClick(toast)">
      <div class="row"
        [class.justify-content-start]="!toast.contentAlignment || toast.contentAlignment === 'left'"
        [class.justify-content-center]="toast.contentAlignment === 'center'"
        [class.justify-content-end]="toast.contentAlignment === 'right'">
        <div class="col-2">
          @switch (toast.type) {
            @case ('success') {
              <svg
                class=""
                [attr.width]="toast.iconSize || 32"
                [attr.height]="toast.iconSize || 32"
                viewBox="0 0 36 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <rect
                  x="0.5"
                  y="1"
                  width="35"
                  height="35"
                  rx="17.5"
                  class="icon-valid"
                  />
                  <g clip-path="url(#clip0_1334_34963)">
                    <path
                      d="M13.9982 24.0598L9.37156 19.4331C8.85156 18.9131 8.01156 18.9131 7.49156 19.4331C6.97156 19.9531 6.97156 20.7931 7.49156 21.3131L13.0649 26.8864C13.5849 27.4064 14.4249 27.4064 14.9449 26.8864L29.0516 12.7798C29.5716 12.2598 29.5716 11.4198 29.0516 10.8998C28.5316 10.3798 27.6916 10.3798 27.1716 10.8998L13.9982 24.0598Z"
                      class="icon-secondary"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1334_34963">
                        <rect
                          width="32"
                          height="32"
                          fill="white"
                          transform="translate(2 2.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  @case ('error') {
                    <svg
                      [attr.width]="toast.iconSize || 32"
                      [attr.height]="toast.iconSize || 32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      >
                      <rect width="24" height="24" rx="12" fill="#FF014D" />
                      <path
                        d="M12.0016 13.0496L8.32656 16.7246C8.18906 16.8621 8.01406 16.9309 7.80156 16.9309C7.58906 16.9309 7.41406 16.8621 7.27656 16.7246C7.13906 16.5871 7.07031 16.4121 7.07031 16.1996C7.07031 15.9871 7.13906 15.8121 7.27656 15.6746L10.9516 11.9996L7.27656 8.32461C7.13906 8.18711 7.07031 8.01211 7.07031 7.79961C7.07031 7.58711 7.13906 7.41211 7.27656 7.27461C7.41406 7.13711 7.58906 7.06836 7.80156 7.06836C8.01406 7.06836 8.18906 7.13711 8.32656 7.27461L12.0016 10.9496L15.6766 7.27461C15.8141 7.13711 15.9891 7.06836 16.2016 7.06836C16.4141 7.06836 16.5891 7.13711 16.7266 7.27461C16.8641 7.41211 16.9328 7.58711 16.9328 7.79961C16.9328 8.01211 16.8641 8.18711 16.7266 8.32461L13.0516 11.9996L16.7266 15.6746C16.8641 15.8121 16.9328 15.9871 16.9328 16.1996C16.9328 16.4121 16.8641 16.5871 16.7266 16.7246C16.5891 16.8621 16.4141 16.9309 16.2016 16.9309C15.9891 16.9309 15.8141 16.8621 15.6766 16.7246L12.0016 13.0496Z"
                        fill="#410306"
                        />
                      </svg>
                    }
                    @case ('warning') {
                      <svg
                        class="fill-warning"
                        [attr.width]="toast.iconSize || 32"
                        [attr.height]="toast.iconSize || 32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <rect width="24" height="24" rx="12" fill="#FFA500" />
                        <path
                          d="M12 7V13M12 17H12.01"
                          stroke="#410306"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          />
                        </svg>
                      }
                      @case ('info') {
                        <svg
                          class="fill-info"
                          [attr.width]="toast.iconSize || 32"
                          [attr.height]="toast.iconSize || 32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          >
                          <rect width="24" height="24" rx="12" fill="#007BFF" />
                          <path
                            d="M12 7V13M12 17H12.01"
                            stroke="#410306"
                            stroke-width="2"
                            stroke-linecap="round"
                          ></path>
                        </svg>
                      }
                    }
                  </div>
                  <div class="col-8">
                    <span
                      [style.margin-left]="toast.marginLeft ? toast.marginLeft + 'px' : '0'"
                      [style.font-size]="toast.fontSize ? toast.fontSize + 'px' : '15px'"
                      [class.fw-bold]="toast.fontWeight === 'bold'"
                      class="{{toast.textColor || ''}}"
                      >
                      {{ toast.message | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }